import Navbar from './Navbar';
import { Link, useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../Services/api";
import { toast } from 'react-toastify';
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { userLogout } from "../redux/authSlice";
import axios from "axios";

export default function Header() {
    const BASE_URL = process.env.REACT_APP_BACKEND_URL_LIVE + 'qualification-list';
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const [name, setName] = useState("")
    const [status, setStatus] = useState(null)
    const [designation, setDesignation] = useState("")
    const { userDetail } = useSelector((state) => state.auth)
    const authType = localStorage.getItem('authType');
    // const { 
    //     data: getQualificationList,
    //     error:error
    // } = useGetQualificationListQuery({  params:''});
    const token = userDetail?.token;

    const header = { Authorization: `Bearer ${token}` };
    useEffect(() => {

        if (userDetail) {
            const authType = localStorage.getItem('authType');
            if (authType === '1') {
                setName(userDetail['user'][0]['name'])
                setDesignation(userDetail['user'][0]['designation'])
            } else {
                setName(userDetail['user'][0]['first_name'])
            }
            axios.get(BASE_URL,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            ).then((response) => {
                setStatus(response.data.status);
            });
        } else {
            if (authType === 1) {
                navigator('/admin');
            } else {
                navigator('/login');
                const response = {
                    userDetail: null,
                    isLoggedIn: false
                };
                dispatch(userLogout(response));
            }

        }
    }, [userDetail, navigator])
    if (status == 401) {
        navigator('/login');
        const response = {
            userDetail: null,
            isLoggedIn: false
        };
        dispatch(userLogout(response));
    }

    const [logout] = useLogoutMutation();
    const logoutUser = (values) => {
        logout({ data: values })
            .unwrap()
            .then((payload) => {

                if (payload.status) {
                    const response = {
                        userDetail: null,
                        isLoggedIn: false
                    };

                    dispatch(userLogout(response));

                    if (authType === 1) {
                        navigator('/admin');
                    } else {
                        navigator('/login');
                    }

                }
            })
            .catch((error) => {
                toast.error(error.data.message)
            });

    };

    const ToggleSidebar = () => {
        const select = (el, all = false) => {
            el = el.trim()
            if (all) {
                return [...document.querySelectorAll(el)]
            } else {
                return document.querySelector(el)
            }
        }
        select('body').classList.toggle('toggle-sidebar')
    }
    const [dateTime, setDateTime] = useState({
        time: '',
        date: '',
    });

    useEffect(() => {
        const updateTime = () => {
            const now = new Date();

            const time = now.toLocaleTimeString('en-US', {
                timeZone: 'Asia/Dubai',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true, // change to true for 12-hour format
            });

            const date = now.toLocaleDateString('en-GB', {
                timeZone: 'Asia/Dubai',
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
            setDateTime({ time, date });
        };
        updateTime(); // set initial
        const interval = setInterval(updateTime, 1000); // update every second
        return () => clearInterval(interval); // cleanup on unmount
    }, []);

    return (
        <>
            <header id="header" className="header fixed-top d-flex align-items-center">
                <div className="d-flex align-items-center justify-content-between">
                    <Link to="/" className="logo d-flex align-items-center">
                        <img src="assets/img/logo.png" alt="" />
                        <span className="d-none d-lg-block">ELEARNING</span>
                    </Link>
                    <i className="bi bi-list toggle-sidebar-btn" onClick={ToggleSidebar}></i>
                </div>
                <p className="text-white text-end w-100 mt-4">{dateTime.date} {dateTime.time}</p>
                <nav className="header-nav ms-auto">
                    <ul className="d-flex align-items-center">
                        <li className="nav-item dropdown pe-3">
                            <Link className="nav-link nav-profile d-flex align-items-center pe-0" to="#" data-bs-toggle="dropdown">
                                {/* <img src="assets/img/profile-img.jpg" alt="Profile" className="rounded-circle" /> */}
                                <span className="d-none d-md-block dropdown-toggle ps-2">{name}</span>
                            </Link>

                            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                                <li className="dropdown-header">
                                    <h6>{name}</h6>
                                    <span>{designation}</span>
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>
                                {authType === 1 ?
                                    <li>
                                        <Link to="/profile" className="dropdown-item d-flex align-items-center">
                                            <i className="bi bi-person"></i>
                                            <span>My Profile</span>
                                        </Link>
                                    </li>
                                    :
                                    <li>
                                        <Link to="/student-profile" className="dropdown-item d-flex align-items-center">
                                            <i className="bi bi-person"></i>
                                            <span>My Profile</span>
                                        </Link>
                                    </li>
                                }

                                <li>
                                    <hr className="dropdown-divider" />
                                </li>
                                <li>
                                    <Link to="/password-update" className="dropdown-item d-flex align-items-center">
                                        <i className="bi bi-person"></i>
                                        <span>Update Password</span>
                                    </Link>
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li>
                                    <Link onClickCapture={logoutUser} className="dropdown-item d-flex align-items-center">
                                        <i className="bi bi-box-arrow-right"></i>
                                        <span>Sign Out</span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            </header>
            <Navbar />
        </>
    );
}